import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LogoutService } from "@/features/auth/services/logout-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { EndpointPathNames } from "@/shared/config/endpoint-path";

export const useLogout = () => {
  const {
    setEmail,
    setUserName,
  } = useLoginContext();
  const navigate = useNavigate();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const logoutService = new LogoutService();

  /*--------------------
    イベント関連
  --------------------*/

  // ログアウトボタン押下
  // NOTE: ログアウト成功時のリダイレクト中にローディングを表示させるため、finallyを使用していない
  const onClickLogout = async () => {
    loadingCtx.setIsLoading(true);
    try {
      await logoutService.postLogout({});
      setEmail("");
      setUserName("");
      sessionStorage.setItem("email", "");
      sessionStorage.setItem("userName", "");
      navigateLogin();
    } catch (error) {
      throw MoneyLinkException.wrapCallback(error, () => {});
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // ログイン画面へ遷移
  const navigateLogin = () => {
    // ブラウザバックで戻れないよう履歴を置換する
    navigate(EndpointPathNames.LOGIN, { replace: true });
  };

  return {
    onClickLogout: errorHandledAsync(onClickLogout, setError),
  };
};
